// eslint-disable-next-line import/prefer-default-export
export const colors = {
  black: '#000',
  white: '#fff',
  gray: {
    50: '#F6F7F9',
    100: '#EDF0F3',
    200: '#DAE1E7',
    300: '#B6C3D0',
    400: '#91A5B8',
    500: '#6D87A1',
    600: '#52697F',
    700: '#354352',
    800: '#1D252D',
    // 900: '#0A0C0F',
  },
  blue: {
    50: '#F2F9FF',
    100: '#E1F1FF',
    200: '#B3DDFF',
    300: '#85C9FF',
    400: '#58B4FF',
    500: '#0072CE',
    600: '#00559B',
    700: '#003967',
    750: '#001F39',
    800: '#001C33',
    900: '#000E1A',
  },
  green: {
    500: '#00B74F',
    700: '#004d21',
    800: '#001f0d'
  }
};
